var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "preview-dialog",
    attrs: {
      "title": "职位预览",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.baseData) ? _c('el-form', {
    staticClass: "preview-inlineForm",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.name) + "【" + _vm._s(_vm.baseData.code) + "】\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位状态",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.getSelectMapText('WB_POSITION_STATE', _vm.baseData.state)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办公地点",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.workPlace) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位序列",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_POSITION_SEQUENCE_ALL', _vm.baseData.sequenceMain)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位子序列",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_POSITION_SEQUENCE_ALL', _vm.baseData.sequenceSub)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布暂停时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.onlineDate ? _vm.baseData.onlineDate.slice(0, 10) : '无') + "\n            至\n            " + _vm._s(_vm.baseData.offlineDate ? _vm.baseData.offlineDate.slice(0, 10) : '无') + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作地点",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.cityNames) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘人数",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.recruitCount || '不限') + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否门户展示",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.showInDesk == 1 ? '是' : '否') + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘范围",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_PROPERTY_TYPE', _vm.baseData.property)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作性质",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.workType) + "\n        ")]), _vm._v(" "), (_vm.baseData.paymentId && _vm.baseData.paymentState) ? _c('el-form-item', {
    attrs: {
      "label": "定薪规则",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.paymentName) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.baseData) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "内推职位",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_YES_OR_NO', _vm.baseData.recommendable) || '-') + "\n        ")]), _vm._v(" "), (_vm.baseData.toSupplier) ? _c('el-form-item', {
    attrs: {
      "label": "供应商",
      "label-width": _vm.formLabelWidth
    }
  }, _vm._l((_vm.baseData.linkmanIdList), function(item) {
    return _c('span', {
      key: item.id,
      staticClass: "mr-15"
    }, [_vm._v(_vm._s(_vm.getSupplierStr(item)))])
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应聘部门",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.deptNames) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.advise) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位职责",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.baseData.description))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "要求",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.baseData.requirement))])])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e24d6de"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/previewPosition.vue
// module id = null
// module chunks = 